import moment from 'moment';

import type { IBillingPeriod, IGracePeriod } from '@feathr/blackbox';

export function getMomentLicenseDate(
  period: IBillingPeriod,
  gracePeriod: IGracePeriod,
  gracePeriodKey: keyof IGracePeriod,
): string {
  const { [gracePeriodKey]: days } = gracePeriod;
  const { [gracePeriodKey]: date } = period;

  return gracePeriodKey === 'start'
    ? moment(date).subtract(days, 'days').format()
    : moment(date).add(days, 'days').format();
}
